import {createSelector} from "@reduxjs/toolkit";
import rootSelector from "../rootSelector";

export const aiAssistantSelector = createSelector(rootSelector, state => state.aiAssistant);
export const aiMetadataSelector = createSelector(aiAssistantSelector, state => state.metadata);
export const aiNodeSettingsSelector = createSelector(aiAssistantSelector, state => state.aiNodeSettings);
export const aiEnabledFeaturesSelector = createSelector(aiAssistantSelector, state => state.enabledFeatures);
